import { useEffect, useState } from "react";

import { ConfirmationModal } from "@/components/ui";
import { DELETE_MAPPING_SESSION_CONFIRM } from "@/lib/mappingReview/constants";

interface DeleteMappingSessionConfirmProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isDeleting: boolean;
  onConfirm: (removeSavedAnswers: boolean) => void;
}

export function DeleteMappingSessionConfirm({
  open,
  onOpenChange,
  isDeleting,
  onConfirm,
}: DeleteMappingSessionConfirmProps) {
  const [removeSavedAnswers, setRemoveSavedAnswers] = useState(false);
  useEffect(() => {
    if (!open) setRemoveSavedAnswers(false);
  }, [open]);
  const { removeSavedAnswersLabel, ...text } = DELETE_MAPPING_SESSION_CONFIRM;

  return (
    <ConfirmationModal
      open={open}
      onOpenChange={onOpenChange}
      {...text}
      variant="danger"
      confirmLabel={isDeleting ? "Deleting..." : "Delete mapping"}
      onConfirm={() => onConfirm(removeSavedAnswers)}
    >
      <label className="mt-4 flex items-center gap-2 text-sm text-slate-700 dark:text-slate-300">
        <input
          type="checkbox"
          data-testid="delete-remove-saved-answers"
          checked={removeSavedAnswers}
          onChange={(e) => setRemoveSavedAnswers(e.target.checked)}
          className="h-4 w-4 rounded border-slate-300 text-rose-600 focus:ring-rose-500 dark:border-slate-600"
        />
        {removeSavedAnswersLabel}
      </label>
    </ConfirmationModal>
  );
}
